import Lightbox from "../classes/Lightbox";

export const initDivVirtualTour = () => {
	const elements = Array.from(document.querySelectorAll(`div.virtual-tour`));	
	
	if (elements.length)
	{
		elements.forEach((element) => element.addEventListener(`click`, () => {
			const currentCity = element.closest(`section`).getAttribute(`data-city`);
			
			const lightbox = new Lightbox();
			const iframe = document.createElement(`iframe`);
			iframe.src = currentCity === `moscow` ? `/panorama-msk/index.html` : `/panorama/index.html`;
			lightbox.open(iframe);
			lightbox.addClasses(`lightbox`, `panorama`);
		}));
	}
};
